<style scoped lang="less">
  @import "../assets/constant";

  .WKheader-wrap {
    width: 100%;
  }
  .WKheader {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 44/@px;
    background:linear-gradient(135deg,rgba(30,18,139,1) 0%,rgba(145,71,178,1) 100%);
    font-size: 16/@px;
    color: #fff;
    z-index: 99999;
    .mid-center;
  }

  .WKheader-icon {
    position: absolute;
    left: 10/@px;
    top: 8/@px;
    width: 28/@px;
    height: 28/@px;
  }
  .WKheader-placeholder {
    height: 44/@px;
  }


</style>

<template>
  <div class="WKheader-wrap">
    <div class="WKheader">
      <img src="../assets/img/left-white-arrow.png" class="WKheader-icon" @click="goBack()"/>
      {{title}}
    </div>
    <div class="WKheader-placeholder"></div>
  </div>
</template>

<script type="text/babel">
  import { goApp } from '../libAndUtils/utils'

  export default {
    data() {
      return {}
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      appBackFlag: {
        type: Boolean,
        default: false
      },

    },
    created() {
      this.isZY = window.location.host.indexOf('zhongyouie') > -1;

    },
    mounted() {
    },
    methods: {
      goBack() {
        if (this.appBackFlag) {
          goApp(this.isZY ? 'app://com.zy.train/meeting/creatBack' : 'app://com.hezy.guide.phone/meeting/creatBack');
        }
        else {
          this.$router.go(-1);
        }
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// WKheader.vue?6bbf0a86